// src/store/attributesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdditionalAttributes } from "src/shared_components/interfaces";
// Adjust the path as needed

export interface AttributesState {
  attributes: Record<string, AdditionalAttributes[]>;
}

const initialState: AttributesState = {
  attributes: {},
};

const attributesSlice = createSlice({
  name: "attributes",
  initialState,
  reducers: {
    setAttributes: (
      state,
      action: PayloadAction<Record<string, AdditionalAttributes[]>>
    ) => {
      state.attributes = action.payload;
    },
  },
});

export const { setAttributes } = attributesSlice.actions;
export default attributesSlice.reducer;
